import React, { useCallback, useEffect, useState } from "react";
import swal from "sweetalert";
import Modals from "../GenericComponents/Modal";
import { get_ApiManager, post_ApiManager } from "../ApiManager/ApiManager";

/**
 * Shared client note modal (same API + fields as ViewClientDetail "Add Note").
 */
export default function ClientAddNoteModal({
  show = false,
  clientId,
  onClose,
  onSuccess,
}) {
  const [emailTags, setEmailTags] = useState([]);

  useEffect(() => {
    if (!show) return undefined;

    get_ApiManager(
      "",
      "getTagsByType/note",
      (res) => {
        if (!res.data?.error) {
          setEmailTags(res.data?.data || []);
        }
      },
      () => {},
    );

    return undefined;
  }, [show]);

  const handleCallback = useCallback(
    (
      check,
      type,
      note,
      notetype,
      client_note,
      processingPriority,
      processingDueDate,
      processingTasks,
      isFinanceNote,
    ) => {
      if (type !== "edit") {
        onClose?.();
        return;
      }

      if (!note) {
        swal({ text: "Please enter note!", icon: "warning", dangerMode: true });
        return;
      }

      if (!notetype) {
        swal({
          text: "Please enter note type!",
          icon: "warning",
          dangerMode: true,
        });
        return;
      }

      if (!clientId) {
        swal(" ", "Client is required to add a note.", "error");
        return;
      }

      const noteData = {
        appid: 0,
        apptype: 0,
        clientid: clientId,
        notes: note,
        apptypefornotification: 4,
        notefor: "clients",
        finalNoteType: isFinanceNote ? 10 : 0,
        noteType: notetype,
        showClientPortal: client_note ? true : false,
      };

      post_ApiManager(
        noteData,
        "notes",
        (res) => {
          if (res.data?.error) {
            swal(" ", res.data.error, "error");
            return;
          }

          swal({
            title: "Success!",
            text: res.data?.message,
            type: "success",
            timer: 1000,
          });
          onClose?.();
          onSuccess?.({ isFinanceNote: Boolean(isFinanceNote) });
        },
        (err) => {
          console.error(err);
        },
      );
    },
    [clientId, onClose, onSuccess],
  );

  return (
    <Modals
      show={show}
      title="Add Note"
      data="Note"
      type="category"
      textarea="true"
      tags={emailTags}
      clientNote={true}
      parentCallback={handleCallback}
    />
  );
}
